module.exports = __webpack_public_path__ + "static/share-66135b14ab2e4be4e58f10c80be249a7.jpg";